module.exports = "//img1.rrcimg.com/_next/static/src/assets/gz_yM6EZ.png";